export default "/_assets/help_info.d999b898.svg"